import React from 'react';
import { _ } from '../../functions/translator';


class ItemInfo extends React.Component{
    render(){ 
        let tableRows = []
        tableRows.push(
            <tr>
                <td>{ _('Avance Real') + ': ' }</td>
                <td>{ this.props.realProgress.toFixed(1) + '%' }</td>
            </tr>
        )
        tableRows.push(
            <tr>
                <td>{ _('Avance Calidad') + ': ' }</td>
                <td>{ this.props.qualityProgress }</td>
            </tr>
        )

        return (
            <div>
                <table className='item-info-table'>
                    {tableRows}
                </table>
            </div>
        );
    }
}

export default ItemInfo